<template>
  <iframe
    v-show="iframe.loaded"
    ref="payment"
    :src="iframe.src"
    frameborder="0"
    height="1200"
    @load="load"
  />
</template>

<script>
export default {
  name: 'RegPack',
  data() {
    return {
      loadFlag: false,
      iframe: {
        src: '../payment.html',
        loaded: false
      }
    };
  },
  methods: {
    load: function () {
      this.iframe.loaded = true;
      setTimeout(() => {
        this.$refs.payment.style.height = this.$refs.payment.contentWindow.document.documentElement.scrollHeight + 'px';
      }, 1500);
    }
  }
};
</script>

<style scoped>

</style>